function determineLoyaltyBonusPointsCampaignType(calculation: Omit<App.LoyaltyPointsEarnCalculation, 'request'>): App.LoyaltyBonusPointsCampaignType | undefined
function determineLoyaltyBonusPointsCampaignType(calculation: App.LoyaltyPointsEarnCalculation): App.LoyaltyBonusPointsCampaignType | undefined {
  if (!calculation.bonusPoints) return
  switch (calculation.bonusPoints / calculation.basePoints) {
    case 1:
      return 'double'
    case 2:
      return 'triple'
    default:
      return 'static'
  }
}

export default determineLoyaltyBonusPointsCampaignType
